import React from "react";
import { Link, NavLink } from "react-router-dom";

function Services() {
  return (
    <section className="Portfolio">
      <div className="port1" style={{ background: "#3D0F41" }}>
        <div className="container">
          <div
            className="row d-flex align-items-center"
            data-aos="fade-down"
            data-aos-easing="ease"
            data-aos-duration="1300"
          >
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="d-flex gap-3 align-items-center">
                <hr className="hr3" />
                <h3 className="heading1 m-0">Services</h3>
              </div>
              <h2>Services We Offer</h2>
              <p>
                Discover a wide range of tailored services designed to meet your
                unique needs. Whether you're looking for expert advice or
                comprehensive solutions, our team is here to support you every
                step of the way.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex align-items-center justify-content-center">
              <Link
                to="/service"
                className="btn_2 "
                style={{ border: "1px solid #FF7627" }}
              >
                View All Services
              </Link>
            </div>
            <hr className="mt-5" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
